<template>
<router-view/>
<footer class="pl-20 pb-10">
  <p class="text-xs text-gray-500">Designed and built by Lustre Digital&nbsp;&nbsp;|&nbsp;&nbsp;{{ new Date().getFullYear() }}</p>
</footer>
</template>
